import i18n from "../../resources/I18n";
import { DsdModale } from "../DSD/DsdModale";
import { INavigationParcours, obtenirNavigationUrl } from "../../util/Navigation";

interface IModaleDonnerControleProps {
  modaleDonnerControleOuvert: boolean;
  onClickModaleDonnerControleFermer: Function;
  cookieParcoursAssurance: INavigationParcours;
  parcours: string;
}

function ModaleDonnerControle(props: Readonly<IModaleDonnerControleProps>) {

  const onClickBoutonDonnerControle = () => {
    window.location.href = `${obtenirNavigationUrl(props.cookieParcoursAssurance.idCallback)}${
      props.parcours
    }/${props.cookieParcoursAssurance.langue}/donnercontrole?idSouscription=${
      props.cookieParcoursAssurance.idSouscription
    }&idAssure=${props.cookieParcoursAssurance.idAssure}`;
  };

  return (
    <DsdModale
      id="dsd-modal-donner-controle"
      dataTestId="dsd-modal-donner-controle"
      show={props.modaleDonnerControleOuvert}
      buttonPrimaryLabel={i18n.t("amc:bouton-principal-modale-donner-controle")}
      buttonSecondaryLabel={i18n.t("amc:bouton-secondaire-modale-annuler")}
      dsdModalSecondaryClick={props.onClickModaleDonnerControleFermer}
      dsdModalPrimaryClick={onClickBoutonDonnerControle}
      spanSlotTitle={i18n.t("amc:titre-modale-donner-controle-la-demande")}
    >
      <p>
        <span dangerouslySetInnerHTML={{ __html: i18n.t("amc:texte-modale-donner-controle")}}></span>
      </p>
    </DsdModale>
  );
}

export default ModaleDonnerControle;
